/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import loadingConfig from "./config/loading.config.json";

const is = require("is_js");

const SERVICE_NAME = "ShelfDetailPageService";
const log: any = LoggerModule.getInstance();

export class ShelfDetailPageService {
  private static instance: ShelfDetailPageService;
  private vapp: VApplication;
  public criteria: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): ShelfDetailPageService {
    if (!ShelfDetailPageService.instance) {
      ShelfDetailPageService.instance = new ShelfDetailPageService(props);
    }
    return ShelfDetailPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getShelfDetail();

    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getBoxes(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    compProps = await agent.getBoxes({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });

    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public getLoading() {
    return { ...(loadingConfig || {}) };
  }

  public async updateShelf(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.updateShelf(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async printShelf(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.printShelf(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async moveToShelf(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.moveToShelf(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
}
